/**
 * Base design intelligence — applies to every brief regardless of dimensions.
 * The least-specific knowledge source; more specific sources refine or override
 * it during composition. Pure data.
 */

export const BASE_KNOWLEDGE = Object.freeze({
  asOf: '2026',
  confidence: 0.5,
  marketUnderstanding: 'Viewers judge a design in seconds; it must communicate its single most important message instantly and guide the eye to one clear action.',
  brandPositioning: ['clear', 'trustworthy'],
  visualTrends: ['strong-hierarchy', 'generous-whitespace', 'confident-typography', 'authentic-imagery'],
  marketingPsychology: ['lead-with-benefit', 'one-primary-action', 'reduce-cognitive-load'],
  colorPsychology: ['contrast-drives-focus', 'limited-palette-reads-premium'],
  typographyDirection: ['clear-hierarchy', 'at-most-two-families'],
  compositionDirection: ['intentional-focal-point', 'align-to-a-grid'],
  photographyDirection: ['authentic', 'high-quality'],
  illustrationDirection: ['purposeful'],
  iconographyDirection: ['consistent-single-set'],
  ctaBehaviour: ['single-primary-cta', 'high-contrast-cta', 'action-verb-label'],
  premiumCues: ['restraint', 'considered-color', 'refined-type', 'generous-whitespace'],
  thingsToAvoid: ['clutter', 'low-contrast', 'default-fonts', 'too-many-typefaces'],
  recommendedGenomes: ['modern', 'minimal'],
  recommendedPatterns: ['feature-row', 'minimal-stack', 'split-hero'],
});
